<template>
  <div class="dashboard__wrap">
    <div class="select__flex_mt">
      <!-- export data dropdown -->
      <div class="maintenance__header">
        <div class="ml-auto  mb-3 form__input">
          <v-date-picker
            mode="range"
            v-model="dateRange"
            :popover="{
              placement: $screens({ default: 'bottom', md: 'bottom-end' })
            }"
            :columns="$screens({ default: 1, lg: 2 })"
            :input-props="{
              class: 'date-picker',
              placeholder: 'Last 30 days',
              readonly: true
            }"
            :min-date="startDate"
            :max-date="new Date()"
            :select-attribute="selectDragAttribute"
            :drag-attribute="selectDragAttribute"
            @drag="dragValue = $event"
          >
            <div slot="day-popover" slot-scope="{ format }">
              {{
                format(dragValue ? dragValue.start : dateRange.start, "MMM D")
              }}
              -
              {{ format(dragValue ? dragValue.end : dateRange.end, "MMM D") }}
            </div>
          </v-date-picker>
        </div>
        <download-csv
          class="alt_btn ml-3 export__btn"
          :class="[
            {
              disabled_csv: exportData.length == 0
            }
          ]"
          :data="exportData"
          :name="`Maintenance Request ${ExportDataName}.csv`"
          :disable="exportLoader"
        >
          <svgicon
            v-if="exportLoader"
            icon="spinner"
            class="button__loader"
          ></svgicon>
          <p v-if="!exportLoader">Export</p>
        </download-csv>
      </div>

      <!-- Search for a maintenance -->
      <div class="mb-5">
        <div class="maintenance__search">
          <input
            type="text"
            class="form__input"
            v-model="searchQuery"
            placeholder="Search by ticket id"
          />
          <button
            class="cta_btn d-flex align-items-center mtn__search_btn"
            @click="searchBy"
            :disabled="!searchQuery"
            :style="[!searchQuery ? { opacity: '0.4' } : { opacity: '1' }]"
          >
            <svgicon
              v-if="searchLoader"
              icon="spinner"
              class="button__loader"
            ></svgicon>
            Search
          </button>
        </div>
      </div>
    </div>
    <!-- show this if the search result returns something -->
    <div v-if="searchResult" style="padding-right:20px;">
      <p
        class="ml-auto"
        style="width:fit-content;cursor:pointer;color:#e30000;font-size:14px;margin-bottom:10px;"
        @click="
          () => {
            searchResult = null;
            searchQuery = '';
          }
        "
      >
        Clear
      </p>
      <div class="dashboard__payment-history-wrap desktop">
        <table class="dashboard__payment-history-table">
          <thead>
            <tr>
              <th class="dashboard__payment-history-table-heading">
                Reason
              </th>
              <th class="dashboard__payment-history-table-heading">
                Space Name
              </th>
              <th class="dashboard__payment-history-table-heading">
                Guest’s Name
              </th>
              <th class="dashboard__payment-history-table-heading">
                Host’s Name
              </th>
              <th class="dashboard__payment-history-table-heading">
                Ticket ID
              </th>
              <th class="dashboard__payment-history-table-heading">
                Date/Time Created
              </th>
              <th class="dashboard__payment-history-table-heading">Status</th>
              <th class="dashboard__payment-history-table-heading"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="dashboard__payment-history-table-data">
                {{ searchResult.type | capitalize }}
              </td>
              <td class="dashboard__payment-history-table-data">
                {{ searchResult.spaceName }}
              </td>
              <td class="dashboard__payment-history-table-data">
                {{ searchResult.memberFullname }}
              </td>
              <td class="dashboard__payment-history-table-data">
                {{ searchResult.hostFullname }}
              </td>
              <td class="dashboard__payment-history-table-data">
                {{ searchResult.ticketId }}
              </td>
              <td class="dashboard__payment-history-table-data">
                {{ searchResult.createdAt | formatOldDateTime }}
              </td>
              <td
                class="dashboard__payment-history-table-data dashboard__listing-table"
              >
                <span
                  class="maintenance__status align-middle"
                  :class="[
                    { completed: searchResult.status == 'completed' },
                    { pending: searchResult.status == 'pending' },
                    { review: searchResult.status == 'in review' },
                    { review: searchResult.status == 'pending decline' },
                    { assessing: searchResult.status == 'assessing' },
                    { follow: searchResult.status == 'follow up' },
                    { declined: searchResult.status == 'declined' },
                    { contested: searchResult.status == 'contested' },
                    { escalated: searchResult.status == 'escalated' },
                    { closed: searchResult.status == 'closed' },
                    { reopened: searchResult.status == 'reopened' }
                  ]"
                  >{{ searchResult.status }}</span
                >
              </td>
              <td class="dashboard__payment-history-table-data">
                <router-link
                  :to="
                    `/maintenance/${searchResult.id}?status=${checkQuery}&page=${getPages}&currentPage=${curPage}`
                  "
                  class="maintenance__table-action"
                  >View</router-link
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- the sort button -->
    <select
      name=""
      v-model="sort"
      id=""
      class="form__select dashboard__filter"
      style="width:243px;"
      v-if="!searchResult"
    >
      <option :value="null" disabled selected>Filter</option>
      <option value="all">All</option>
      <option value="pending">Pending</option>
      <option value="in review">In Review</option>
      <option value="pending decline">Request to Declined</option>
      <option value="assessing">Assessing</option>
      <option value="follow up">Follow Up</option>
      <option value="completed">Completed</option>
      <option value="reopened">Reopended</option>
      <option value="escalated">Escalated</option>
      <option value="declined">Declined</option>
      <option value="closed">Closed</option>
    </select>

    <div class="admin-dashboard__tab" v-if="!searchResult">
      <b-tabs>
        <b-tab
          :active="checkQuery === 'all'"
          @click="currentTab(allPages, allPageSize, 'all')"
          class="position-relative"
        >
          <!-- <template #title>
            Pending
            <span :style="[pendingTotal > 0 ? { color: 'red' } : {}]"
              >({{ pendingTotal }})</span
            >
          </template> -->

          <div class="dashboard__payment-history-wrap position-relative">
            <table
              class="dashboard__payment-history-table"
              style="min-width:1000px"
            >
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading"></th>
                  <th class="dashboard__payment-history-table-heading">
                    Reason
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Space Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Guest’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Host’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Ticket ID
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Date/Time Created
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                  <th class="dashboard__payment-history-table-heading"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(request, index) in all" :key="index">
                  <td class="dashboard__payment-history-table-data ">
                    {{ pageNumber(index + 1, allCurrentPage, allPageSize) }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.type | capitalize }}
                  </td>
                  <!-- <td class="dashboard__payment-history-table-data">
                    {{ request.type | capitalize }}
                  </td> -->
                  <td class="dashboard__payment-history-table-data">
                    {{ request.spaceName }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.memberFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.hostFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.ticketId }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.createdAt | formatOldDateTime }}
                  </td>
                  <!-- the status of each request -->
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    <span
                      class="maintenance__status align-middle"
                      :class="[
                        { completed: request.status == 'completed' },
                        { pending: request.status == 'pending' },
                        { review: request.status == 'in review' },
                        { review: request.status == 'pending decline' },
                        { assessing: request.status == 'assessing' },
                        { follow: request.status == 'follow up' },
                        { declined: request.status == 'declined' },
                        { contested: request.status == 'contested' },
                        { escalated: request.status == 'escalated' },
                        { closed: request.status == 'closed' },
                        { reopened: request.status == 'reopened' }
                      ]"
                      >{{ request.status }}</span
                    >
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <router-link
                      :to="
                        `/maintenance/${request.id}?status=${checkQuery}&page=${getPages}&currentPage=${curPage}`
                      "
                      class="maintenance__table-action"
                      >View</router-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <Loader :loader="allLoading" class="innerLoader" />
          </div>
          <div class="dashboard__empty" v-if="all.length === 0">
            <div class="dashboard__booking-empty">
              <img
                src="../../assets/illustrations/noBookings.svg"
                alt=""
                class="img-fluid"
              />
            </div>
            <p class="dashboard__booking-empty-text">
              You have no requests here.
            </p>
          </div>
          <div class="dashboard__pagination" v-if="all.length > 0">
            <b-pagination
              pills
              v-model="curPage"
              :total-rows="allTotal"
              :per-page="allPageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination($event, 'all')"
            ></b-pagination>
          </div>
        </b-tab>
        <b-tab
          :active="checkQuery === 'pending'"
          @click="currentTab(pendingPages, pendingPageSize, 'pending')"
          class="position-relative"
        >
          <!-- <template #title>
            Pending
            <span :style="[pendingTotal > 0 ? { color: 'red' } : {}]"
              >({{ pendingTotal }})</span
            >
          </template> -->

          <div class="dashboard__payment-history-wrap position-relative">
            <table
              class="dashboard__payment-history-table"
              style="min-width:1000px"
            >
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading"></th>
                  <th class="dashboard__payment-history-table-heading">
                    Reason
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Space Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Guest’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Host’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Ticket ID
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Date/Time Created
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                  <th class="dashboard__payment-history-table-heading"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(request, index) in pending" :key="index">
                  <td class="dashboard__payment-history-table-data ">
                    {{
                      pageNumber(index + 1, pendingCurrentPage, pendingPageSize)
                    }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.type | capitalize }}
                  </td>
                  <!-- <td class="dashboard__payment-history-table-data">
                    {{ request.type | capitalize }}
                  </td> -->
                  <td class="dashboard__payment-history-table-data">
                    {{ request.spaceName }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.memberFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.hostFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.ticketId }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.createdAt | formatOldDateTime }}
                  </td>
                  <!-- the status of each request -->
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    <span
                      class="maintenance__status align-middle"
                      :class="[{ pending: request.status == 'pending' }]"
                      >{{ request.status }}</span
                    >
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <router-link
                      :to="
                        `/maintenance/${request.id}?status=${checkQuery}&page=${getPages}&currentPage=${curPage}`
                      "
                      class="maintenance__table-action"
                      >View</router-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <Loader :loader="pendingLoading" class="innerLoader" />
          </div>
          <div class="dashboard__empty" v-if="pending.length === 0">
            <div class="dashboard__booking-empty">
              <img
                src="../../assets/illustrations/noBookings.svg"
                alt=""
                class="img-fluid"
              />
            </div>
            <p class="dashboard__booking-empty-text">
              You have no requests here.
            </p>
          </div>
          <div class="dashboard__pagination" v-if="pending.length > 0">
            <b-pagination
              pills
              v-model="curPage"
              :total-rows="pendingTotal"
              :per-page="pendingPageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination($event, 'pending')"
            ></b-pagination>
          </div>
        </b-tab>
        <b-tab
          @click="currentTab(reviewPages, reviewPageSize, 'in review')"
          :active="checkQuery === 'in review'"
          class="position-relative"
        >
          <!-- <template #title>
            In Review
            <span :style="[reviewTotal > 0 ? { color: 'red' } : {}]"
              >({{ reviewTotal }})</span
            >
          </template> -->
          <div class="dashboard__payment-history-wrap position-relative">
            <table
              class="dashboard__payment-history-table"
              style="min-width:1000px"
            >
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading"></th>
                  <th class="dashboard__payment-history-table-heading">
                    Reason
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Space Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Guest’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Host’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Ticket ID
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Date/Time Created
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                  <th class="dashboard__payment-history-table-heading"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(request, index) in review" :key="index">
                  <td class="dashboard__payment-history-table-data ">
                    {{
                      pageNumber(index + 1, reviewCurrentPage, reviewPageSize)
                    }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.type | capitalize }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.spaceName }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.memberFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.hostFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.ticketId }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.createdAt | formatOldDateTime }}
                  </td>
                  <!-- the status of each request -->
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    <span
                      class="maintenance__status align-middle"
                      :class="[{ review: request.status == 'in review' }]"
                      >{{ request.status }}</span
                    >
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <router-link
                      :to="
                        `/maintenance/${request.id}?status=${checkQuery}&page=${getPages}&currentPage=${curPage}`
                      "
                      class="maintenance__table-action"
                      >View</router-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <Loader :loader="reviewLoading" class="innerLoader" />
          </div>
          <div class="dashboard__empty" v-if="review.length === 0">
            <div class="dashboard__booking-empty">
              <img
                src="../../assets/illustrations/noBookings.svg"
                alt=""
                class="img-fluid"
              />
            </div>
            <p class="dashboard__booking-empty-text">
              You have no requests here.
            </p>
          </div>
          <div class="dashboard__pagination" v-if="review.length > 0">
            <b-pagination
              pills
              v-model="curPage"
              :total-rows="reviewTotal"
              :per-page="reviewPageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination($event, 'in review')"
            ></b-pagination>
          </div>
        </b-tab>
        <b-tab
          @click="
            currentTab(toDeclinePages, toDeclinePageSize, 'pending decline')
          "
          :active="checkQuery === 'pending decline'"
          class="position-relative"
        >
          <div class="dashboard__payment-history-wrap position-relative">
            <table
              class="dashboard__payment-history-table"
              style="min-width:1000px"
            >
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading"></th>
                  <th class="dashboard__payment-history-table-heading">
                    Reason
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Space Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Guest’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Host’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Ticket ID
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Date/Time Created
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                  <th class="dashboard__payment-history-table-heading"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(request, index) in toDecline" :key="index">
                  <td class="dashboard__payment-history-table-data ">
                    {{
                      pageNumber(
                        index + 1,
                        toDeclineCurrentPage,
                        toDeclinePageSize
                      )
                    }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.type | capitalize }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.spaceName }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.memberFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.hostFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.ticketId }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.createdAt | formatOldDateTime }}
                  </td>
                  <!-- the status of each request -->
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    <span
                      class="maintenance__status align-middle"
                      :class="[{ review: request.status == 'pending decline' }]"
                      >{{ request.status }}</span
                    >
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <router-link
                      :to="
                        `/maintenance/${request.id}?status=${checkQuery}&page=${getPages}&currentPage=${curPage}`
                      "
                      class="maintenance__table-action"
                      >View</router-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <Loader :loader="toDeclineLoading" class="innerLoader" />
          </div>
          <div class="dashboard__empty" v-if="toDecline.length === 0">
            <div class="dashboard__booking-empty">
              <img
                src="../../assets/illustrations/noBookings.svg"
                alt=""
                class="img-fluid"
              />
            </div>
            <p class="dashboard__booking-empty-text">
              You have no requests here.
            </p>
          </div>
          <div class="dashboard__pagination" v-if="toDecline.length > 0">
            <b-pagination
              pills
              v-model="curPage"
              :total-rows="toDeclineTotal"
              :per-page="toDeclinePageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination($event, 'pending decline')"
            ></b-pagination>
          </div>
        </b-tab>
        <b-tab
          @click="currentTab(assessingPages, assessingPageSize, 'assessing')"
          :active="checkQuery === 'assessing'"
          class="position-relative"
        >
          <div class="dashboard__payment-history-wrap position-relative">
            <table
              class="dashboard__payment-history-table"
              style="min-width:1000px"
            >
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading"></th>
                  <th class="dashboard__payment-history-table-heading">
                    Reason
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Space Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Guest’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Host’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Ticket ID
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Date/Time Created
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                  <th class="dashboard__payment-history-table-heading"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(request, index) in assessing" :key="index">
                  <td class="dashboard__payment-history-table-data ">
                    {{
                      pageNumber(
                        index + 1,
                        assessingCurrentPage,
                        assessingPageSize
                      )
                    }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.type | capitalize }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.spaceName }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.memberFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.hostFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.ticketId }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.createdAt | formatOldDateTime }}
                  </td>
                  <!-- the status of each request -->
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    <span
                      class="maintenance__status align-middle"
                      :class="[{ assessing: request.status == 'assessing' }]"
                      >{{ request.status }}</span
                    >
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <router-link
                      :to="
                        `/maintenance/${request.id}?status=${checkQuery}&page=${getPages}&currentPage=${curPage}`
                      "
                      class="maintenance__table-action"
                      >View</router-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <Loader :loader="assessingLoading" class="innerLoader" />
          </div>
          <div class="dashboard__empty" v-if="assessing.length === 0">
            <div class="dashboard__booking-empty">
              <img
                src="../../assets/illustrations/noBookings.svg"
                alt=""
                class="img-fluid"
              />
            </div>
            <p class="dashboard__booking-empty-text">
              You have no requests here.
            </p>
          </div>
          <div class="dashboard__pagination" v-if="assessing.length > 0">
            <b-pagination
              pills
              v-model="curPage"
              :total-rows="assessingTotal"
              :per-page="assessingPageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination($event, 'assessing')"
            ></b-pagination>
          </div>
        </b-tab>
        <b-tab
          @click="currentTab(followupPages, followupPageSize, 'follow up')"
          class="position-relative"
          :active="checkQuery === 'follow up'"
        >
          <div class="dashboard__payment-history-wrap position-relative">
            <table
              class="dashboard__payment-history-table"
              style="min-width:1000px"
            >
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading"></th>
                  <th class="dashboard__payment-history-table-heading">
                    Reason
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Space Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Guest’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Host’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Ticket ID
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Date/Time Created
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                  <th class="dashboard__payment-history-table-heading"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(request, index) in followup" :key="index">
                  <td class="dashboard__payment-history-table-data ">
                    {{
                      pageNumber(
                        index + 1,
                        followupCurrentPage,
                        followupPageSize
                      )
                    }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.type | capitalize }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.spaceName }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.memberFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.hostFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.ticketId }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.createdAt | formatOldDateTime }}
                  </td>
                  <!-- the status of each request -->
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    <span
                      class="maintenance__status align-middle"
                      :class="[{ follow: request.status == 'follow up' }]"
                      >{{ request.status }}</span
                    >
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <router-link
                      :to="
                        `/maintenance/${request.id}?status=${checkQuery}&page=${getPages}&currentPage=${curPage}`
                      "
                      class="maintenance__table-action"
                      >View</router-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <Loader :loader="followupLoading" class="innerLoader" />
          </div>
          <div class="dashboard__empty" v-if="followup.length === 0">
            <div class="dashboard__booking-empty">
              <img
                src="../../assets/illustrations/noBookings.svg"
                alt=""
                class="img-fluid"
              />
            </div>
            <p class="dashboard__booking-empty-text">
              You have no requests here.
            </p>
          </div>
          <div class="dashboard__pagination" v-if="followup.length > 0">
            <b-pagination
              pills
              v-model="curPage"
              :total-rows="followupTotal"
              :per-page="followupPageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination($event, 'follow up')"
            ></b-pagination>
          </div>
        </b-tab>
        <b-tab
          @click="currentTab(completedPages, completedPageSize, 'completed')"
          class="position-relative"
          :active="checkQuery === 'completed'"
        >
          <div class="dashboard__payment-history-wrap position-relative">
            <table
              class="dashboard__payment-history-table"
              style="min-width:1000px"
            >
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading"></th>
                  <th class="dashboard__payment-history-table-heading">
                    Reason
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Space Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Guest’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Host’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Ticket ID
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Date/Time Created
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                  <th class="dashboard__payment-history-table-heading"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(request, index) in completed" :key="index">
                  <td class="dashboard__payment-history-table-data ">
                    {{
                      pageNumber(
                        index + 1,
                        completedCurrentPage,
                        completedPageSize
                      )
                    }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.type | capitalize }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.spaceName }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.memberFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.hostFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.ticketId }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.createdAt | formatOldDateTime }}
                  </td>
                  <!-- the status of each request -->
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    <span
                      class="maintenance__status align-middle"
                      :class="[{ completed: request.status == 'completed' }]"
                      >{{ request.status }}</span
                    >
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <router-link
                      :to="
                        `/maintenance/${request.id}?status=${checkQuery}&page=${getPages}&currentPage=${curPage}`
                      "
                      class="maintenance__table-action"
                      >View</router-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <Loader :loader="completedLoading" class="innerLoader" />
          </div>
          <div class="dashboard__empty" v-if="completed.length === 0">
            <div class="dashboard__booking-empty">
              <img
                src="../../assets/illustrations/noBookings.svg"
                alt=""
                class="img-fluid"
              />
            </div>
            <p class="dashboard__booking-empty-text">
              You have no requests here.
            </p>
          </div>
          <div class="dashboard__pagination" v-if="completed.length > 0">
            <b-pagination
              pills
              v-model="curPage"
              :total-rows="completedTotal"
              :per-page="completedPageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination($event, 'completed')"
            ></b-pagination>
          </div>
        </b-tab>
        <b-tab
          @click="currentTab(reopenedPages, reopenedPageSize, 'reopened')"
          class="position-relative"
          :active="checkQuery === 'reopened'"
        >
          <div class="dashboard__payment-history-wrap position-relative">
            <table
              class="dashboard__payment-history-table"
              style="min-width:1000px"
            >
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading"></th>
                  <th class="dashboard__payment-history-table-heading">
                    Reason
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Space Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Guest’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Host’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Ticket ID
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Date/Time Created
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                  <th class="dashboard__payment-history-table-heading"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(request, index) in reopened" :key="index">
                  <td class="dashboard__payment-history-table-data ">
                    {{
                      pageNumber(
                        index + 1,
                        reopenedCurrentPage,
                        reopenedPageSize
                      )
                    }}
                  </td>

                  <td class="dashboard__payment-history-table-data">
                    {{ request.type | capitalize }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.spaceName }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.memberFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.hostFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.ticketId }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.createdAt | formatOldDateTime }}
                  </td>
                  <!-- the status of each request -->
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    <span
                      class="maintenance__status align-middle"
                      :class="[{ reopened: request.status == 'reopened' }]"
                      >{{ request.status }}</span
                    >
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <router-link
                      :to="
                        `/maintenance/${request.id}?status=${checkQuery}&page=${getPages}&currentPage=${curPage}`
                      "
                      class="maintenance__table-action"
                      >View</router-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <Loader :loader="reopenedLoading" class="innerLoader" />
          </div>
          <div class="dashboard__empty" v-if="reopened.length === 0">
            <div class="dashboard__booking-empty">
              <img
                src="../../assets/illustrations/noBookings.svg"
                alt=""
                class="img-fluid"
              />
            </div>
            <p class="dashboard__booking-empty-text">
              You have no requests here.
            </p>
          </div>
          <div class="dashboard__pagination" v-if="reopened.length > 0">
            <b-pagination
              pills
              v-model="curPage"
              :total-rows="reopenedTotal"
              :per-page="reopenedPageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination($event, 'reopened')"
            ></b-pagination>
          </div>
        </b-tab>
        <b-tab
          @click="currentTab(escalatedPages, escalatedPageSize, 'escalated')"
          class="position-relative"
          :active="checkQuery === 'escalated'"
        >
          <div class="dashboard__payment-history-wrap position-relative">
            <table
              class="dashboard__payment-history-table"
              style="min-width:1000px"
            >
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading"></th>
                  <th class="dashboard__payment-history-table-heading">
                    Reason
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Space Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Guest’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Host’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Ticket ID
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Date/Time Created
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                  <th class="dashboard__payment-history-table-heading"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(request, index) in escalated" :key="index">
                  <td class="dashboard__payment-history-table-data ">
                    {{
                      pageNumber(
                        index + 1,
                        escalatedCurrentPage,
                        escalatedPageSize
                      )
                    }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.type | capitalize }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.spaceName }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.memberFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.hostFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.ticketId }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.createdAt | formatOldDateTime }}
                  </td>
                  <!-- the status of each request -->
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    <span
                      class="maintenance__status align-middle"
                      :class="[{ escalated: request.status == 'escalated' }]"
                      >{{ request.status }}</span
                    >
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <router-link
                      :to="
                        `/maintenance/${request.id}?status=${checkQuery}&page=${getPages}&currentPage=${curPage}`
                      "
                      class="maintenance__table-action"
                      >View</router-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <Loader :loader="escalatedLoading" class="innerLoader" />
          </div>
          <div class="dashboard__empty" v-if="escalated.length === 0">
            <div class="dashboard__booking-empty">
              <img
                src="../../assets/illustrations/noBookings.svg"
                alt=""
                class="img-fluid"
              />
            </div>
            <p class="dashboard__booking-empty-text">
              You have no requests here.
            </p>
          </div>
          <div class="dashboard__pagination" v-if="escalated.length > 0">
            <b-pagination
              pills
              v-model="curPage"
              :total-rows="escalatedTotal"
              :per-page="escalatedPageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination($event, 'escalated')"
            ></b-pagination>
          </div>
        </b-tab>
        <b-tab
          @click="currentTab(declinedPages, declinedPageSize, 'declined')"
          class="position-relative"
          :active="checkQuery === 'declined'"
        >
          <div class="dashboard__payment-history-wrap position-relative">
            <table
              class="dashboard__payment-history-table"
              style="min-width:1000px"
            >
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading"></th>
                  <th class="dashboard__payment-history-table-heading">
                    Reason
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Space Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Guest’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Host’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Ticket ID
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Date/Time Created
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                  <th class="dashboard__payment-history-table-heading"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(request, index) in declined" :key="index">
                  <td class="dashboard__payment-history-table-data ">
                    {{
                      pageNumber(
                        index + 1,
                        declinedCurrentPage,
                        declinedPageSize
                      )
                    }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.type | capitalize }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.spaceName }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.memberFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.hostFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.ticketId }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.createdAt | formatOldDateTime }}
                  </td>
                  <!-- the status of each request -->
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    <span
                      class="maintenance__status align-middle"
                      :class="[{ declined: request.status == 'declined' }]"
                      >{{ request.status }}</span
                    >
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <router-link
                      :to="
                        `/maintenance/${request.id}?status=${checkQuery}&page=${getPages}&currentPage=${curPage}`
                      "
                      class="maintenance__table-action"
                      >View</router-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <Loader :loader="declinedLoading" class="innerLoader" />
          </div>
          <div class="dashboard__empty" v-if="declined.length === 0">
            <div class="dashboard__booking-empty">
              <img
                src="../../assets/illustrations/noBookings.svg"
                alt=""
                class="img-fluid"
              />
            </div>
            <p class="dashboard__booking-empty-text">
              You have no requests here.
            </p>
          </div>
          <div class="dashboard__pagination" v-if="declined.length > 0">
            <b-pagination
              pills
              v-model="curPage"
              :total-rows="declinedTotal"
              :per-page="declinedPageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination($event, 'declined')"
            ></b-pagination>
          </div>
        </b-tab>
        <b-tab
          @click="currentTab(closedPages, closedPageSize, 'closed')"
          class="position-relative"
          :active="checkQuery === 'closed'"
        >
          <div class="dashboard__payment-history-wrap position-relative">
            <table
              class="dashboard__payment-history-table"
              style="min-width:1000px"
            >
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading"></th>
                  <th class="dashboard__payment-history-table-heading">
                    Reason
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Space Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Guest’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Host’s Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Ticket ID
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Date/Time Created
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                  <th class="dashboard__payment-history-table-heading"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(request, index) in closed" :key="index">
                  <td class="dashboard__payment-history-table-data ">
                    {{
                      pageNumber(index + 1, closedCurrentPage, closedPageSize)
                    }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.type | capitalize }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.spaceName }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.memberFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.hostFullname }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.ticketId }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ request.createdAt | formatOldDateTime }}
                  </td>
                  <!-- the status of each request -->
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    <span
                      class="maintenance__status align-middle"
                      :class="[{ closed: request.status == 'closed' }]"
                      >{{ request.status }}</span
                    >
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <router-link
                      :to="
                        `/maintenance/${request.id}?status=${checkQuery}&page=${getPages}&currentPage=${curPage}`
                      "
                      class="maintenance__table-action"
                      >View</router-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <Loader :loader="closedLoading" class="innerLoader" />
          </div>
          <div class="dashboard__empty" v-if="closed.length === 0">
            <div class="dashboard__booking-empty">
              <img
                src="../../assets/illustrations/noBookings.svg"
                alt=""
                class="img-fluid"
              />
            </div>
            <p class="dashboard__booking-empty-text">
              You have no requests here.
            </p>
          </div>
          <div class="dashboard__pagination" v-if="closed.length > 0">
            <b-pagination
              pills
              v-model="curPage"
              :total-rows="closedTotal"
              :per-page="closedPageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination($event, 'closed')"
            ></b-pagination>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import {
  getRequest,
  maintenanceSearchBy,
  getMaintenanceExportData
} from "../../../services/maintenance";
import Loader from "../resuables/loader.vue";
import exportDataDropdown from "../resuables/export-data.vue";
import moment from "moment";

export default {
  name: "maintenance",
  components: {
    Loader,
    exportDataDropdown
  },
  data() {
    return {
      startDate: "2021-04-16",
      dragValue: null,
      exportData: [],
      exportLoader: false,
      dateRange: {
        end: new Date(),
        start: new Date(new Date().setDate(new Date().getDate() - 30))
      },

      all: [],
      allCurrentPage: 1,
      allPageSize: 10,
      allTotal: 0,
      allPages: 0,
      allLoading: false,

      pending: [],
      pendingCurrentPage: 1,
      pendingPageSize: 10,
      pendingTotal: 0,
      pendingPages: 0,
      pendingLoading: false,

      review: [],
      reviewCurrentPage: 1,
      reviewPageSize: 10,
      reviewTotal: 0,
      reviewPages: 0,
      reviewLoading: false,
      sort: "all",

      toDecline: [],
      toDeclineCurrentPage: 1,
      toDeclinePageSize: 10,
      toDeclineTotal: 0,
      toDeclinePages: 0,
      toDeclineLoading: false,

      assessing: [],
      assessingCurrentPage: 1,
      assessingPageSize: 10,
      assessingTotal: 0,
      assessingPages: 0,
      assessingLoading: false,

      followup: [],
      followupCurrentPage: 1,
      followupPageSize: 10,
      followupTotal: 0,
      followupPages: 0,
      followupLoading: false,

      completed: [],
      completedCurrentPage: 1,
      completedPageSize: 10,
      completedTotal: 0,
      completedPages: 0,
      completedLoading: false,

      reopened: [],
      reopenedPageSize: 10,
      reopenedTotal: 0,
      reopenedPages: 0,
      reopenedLoading: false,
      reopenedCurrentPage: 1,

      escalated: [],
      escalatedPageSize: 10,
      escalatedPages: 0,
      escalatedTotal: 0,
      escalatedLoading: false,
      escalatedCurrentPage: 1,

      loader: false,
      active: "",

      closed: [],
      closedCurrentPage: 1,
      closedPageSize: 10,
      closedTotal: 0,
      closedPages: 0,
      closedLoading: false,

      searchQuery: "",
      searchLoader: false,
      searchResult: null,

      declined: [],
      declinedCurrentPage: 1,
      declinedPageSize: 10,
      declinedTotal: 0,
      declinedPages: 0,
      declinedLoading: false,

      filterClosedDeclined: "All",
      filterReopenedEscalated: "All",
      filterMenu: false,

      pageSize: 10,

      showdataOptions: false
    };
  },
  watch: {
    dateRange(newValue) {
      if (newValue) {
        this.getAllExportData();
      }
    },
    sort(newValue) {
      const page = 1;

      if (newValue === "all") {
        this.allCurrentPage = 1;
        this.currentTab(page, this.allPageSize, "all");
      }
      if (newValue === "pending") {
        this.pendingCurrentPage = 1;
        this.currentTab(page, this.pendingPageSize, "pending");
      }
      if (newValue === "in review") {
        this.reviewCurrentPage = 1;
        this.currentTab(page, this.reviewPageSize, "in review");
      }
      if (newValue === "pending decline") {
        this.toDeclineCurrentPage = 1;
        this.currentTab(page, this.toDeclinePageSize, "pending decline");
      }
      if (newValue === "assessing") {
        this.assessingCurrentPage = 1;
        this.currentTab(page, this.assessingPageSize, "assessing");
      }
      if (newValue === "follow up") {
        this.followupCurrentPage = 1;
        this.currentTab(page, this.followupPageSize, "follow up");
      }
      if (newValue === "completed") {
        this.completedCurrentPage = 1;
        this.currentTab(page, this.completedPageSize, "completed");
      }
      if (newValue === "reopened") {
        this.reopenedCurrentPage = 1;
        this.currentTab(page, this.reopenedPageSize, "reopened");
      }
      if (newValue === "escalated") {
        this.escalatedCurrentPage = 1;
        this.currentTab(page, this.escalatedPageSize, "escalated");
      }
      if (newValue === "declined") {
        this.declinedCurrentPage = 1;
        this.currentTab(page, this.declinedPageSize, "declined");
      }
      if (newValue === "closed") {
        this.closedCurrentPage = 1;
        this.currentTab(page, this.closedPageSize, "closed");
      }
    },
    "$route.query": {
      immediate: true,
      handler(query) {
        const page = Number(query.page) || 1;
        const status = query.status || "all";
        this.active = status;
        this.getRequest(page, this.pageSize, status);
      },
      deep: true
    }
  },
  methods: {
    formatExportDataName(value) {
      if (!value) return "";
      return moment(value).format("YYYY-MM-DD");
    },
    getAllExportData() {
      this.exportLoader = true;
      const statusType = this.active.length > 1 ? this.active : "pending";
      const payload = {
        startDate: moment(this.dateRange.start).format("YYYY-MM-DD"),
        endDate: moment(this.dateRange.end).format("YYYY-MM-DD"),
        status: statusType == "all" ? "" : statusType
      };

      getMaintenanceExportData(payload)
        .then(res => {
          this.exportLoader = false;
          if (res.statusCode === 200) {
            // if the maintenance request array length is 0, show a toast
            if (res.data.maintenanceRequests.length == 0) {
              this.$notification.error({
                message: "Maintenance request",
                description: "No data to export"
              });
              return;
            }
            this.exportData = res.data.maintenanceRequests.map(el => {
              return {
                createdAt: el.createdAt,
                description: el.description,
                id: el.id,
                issueDate: el.issueDate,
                status: el.status,
                type: el.type,
                updatedAt: el.updatedAt
              };
            });
          }
        })
        .catch(err => {
          this.exportLoader = false;
          return err;
        });
    },
    pageNumber(index, currentPage, pageSize) {
      if (currentPage < 2) {
        return index;
      } else {
        return pageSize * (currentPage - 1) + index;
      }
    },
    getCleanStatus() {
      return (this.$route.query.status || "all").toLowerCase();
    },
    pageQueryFromParams() {
      const status = this.getCleanStatus();

      if (status === "all") {
        this.allPages = this.getPages;
        this.sllCurrentPage = this.curPage;
      } else if (status === "pending") {
        this.pendingPages = this.getPages;
        this.pendingCurrentPage = this.curPage;
      } else if (status === "in review") {
        this.reviewPages = this.getPages;
        this.reviewCurrentPage = this.curPage;
      } else if (status === "pending decline") {
        this.toDeclinePages = this.getPages;
        this.toDeclineCurrentPage = this.curPage;
      } else if (status === "assessing") {
        this.assessingPages = this.getPages;
        this.assessingCurrentPage = this.curPage;
      } else if (status === "follow up") {
        this.followupPages = this.getPages;
        this.followupCurrentPage = this.curPage;
      } else if (status === "completed") {
        this.completedPages = this.getPages;
        this.completedCurrentPage = this.curPage;
      } else if (status === "reopened") {
        this.reopenedPages = this.getPages;
        this.reopenedCurrentPage = this.curPage;
      } else if (status === "escalated") {
        this.escalatedPages = this.getPages;
        this.escalatedCurrentPage = this.curPage;
      } else if (status === "declined") {
        this.declinedPages = this.getPages;
        this.declinedCurrentPage = this.curPage;
      }
    },
    currentTab(page, pageSize, type) {
      this.active = type;

      this.$router.replace(
        `/maintenance?status=${encodeURIComponent(
          type
        )}&page=${page}&currentPage=${page}`
      );

      // const offset = (page - 1) * pageSize;
      this.getRequest(page, pageSize, type);
    },
    searchBy() {
      this.searchLoader = true;
      maintenanceSearchBy(this.searchQuery)
        .then(res => {
          this.searchLoader = false;
          this.searchResult = res.data.data;
        })
        .catch(err => {
          this.searchLoader = false;
          this.$notification.error({
            message: "Search error",
            description: err.response.data.message
          });
        });
    },
    sortRequest(a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt);
    },
    getRequest(page, pageSize, type) {
      if (type === "all" && this.all.length === 0) {
        this.allLoading = true;
      } else if (type === "pending" && this.pending.length === 0) {
        this.pendingLoading = true;
      } else if (type === "in review" && this.review.length === 0) {
        this.reviewLoading = true;
      } else if (type === "pending decline" && this.toDecline.length === 0) {
        this.toDeclineLoading = true;
      } else if (type === "assessing" && this.assessing.length === 0) {
        this.assessingLoading = true;
      } else if (type === "follow up" && this.followup.length === 0) {
        this.followupLoading = true;
      } else if (type === "completed" && this.completed.length === 0) {
        this.completedLoading = true;
      } else if (type === "reopened" && this.reopened.length === 0) {
        this.reopenedLoading = true;
      } else if (type === "escalated" && this.escalated.length === 0) {
        this.escalatedLoading = true;
      } else if (type === "declined" && this.declined.length === 0) {
        this.declinedLoading = true;
      } else if (type === "closed" && this.closed.length === 0) {
        this.closedLoading = true;
      }
      getRequest(page, pageSize, type)
        .then(res => {
          this.loader = false;
          if (type === "all") {
            this.all = res.data.data.maintenanceRequests.sort(this.sortRequest);
            this.allTotal = res.data.data.totalMaintenance;
            this.allLoading = false;
          } else if (type === "pending") {
            this.pending = res.data.data.maintenanceRequests.sort(
              this.sortRequest
            );
            this.pendingTotal = res.data.data.totalMaintenance;
            this.pendingLoading = false;
          } else if (type === "in review") {
            this.review = res.data.data.maintenanceRequests.sort(
              this.sortRequest
            );
            this.reviewTotal = res.data.data.totalMaintenance;
            this.reviewLoading = false;
          } else if (type === "pending decline") {
            this.toDecline = res.data.data.maintenanceRequests.sort(
              this.sortRequest
            );
            this.toDeclineTotal = res.data.data.totalMaintenance;
            this.toDeclineLoading = false;
          } else if (type === "assessing") {
            this.assessing = res.data.data.maintenanceRequests.sort(
              this.sortRequest
            );
            this.assessingTotal = res.data.data.totalMaintenance;
            this.assessingLoading = false;
          } else if (type === "follow up") {
            this.followup = res.data.data.maintenanceRequests.sort(
              this.sortRequest
            );
            this.followupTotal = res.data.data.totalMaintenance;
            this.followupLoading = false;
          } else if (type === "completed") {
            this.completed = res.data.data.maintenanceRequests.sort(
              this.sortRequest
            );
            this.completedTotal = res.data.data.totalMaintenance;
            this.completedLoading = false;
          } else if (type === "reopened") {
            this.reopened = res.data.data.maintenanceRequests.sort(
              this.sortRequest
            );
            this.reopenedTotal = res.data.data.totalMaintenance;
            this.reopenedLoading = false;
          } else if (type === "escalated") {
            this.escalated = res.data.data.maintenanceRequests.sort(
              this.sortRequest
            );
            this.escalatedTotal = res.data.data.totalMaintenance;
            this.escalatedLoading = false;
          } else if (type === "declined") {
            this.declined = res.data.data.maintenanceRequests.sort(
              this.sortRequest
            );
            this.declinedTotal = res.data.data.totalMaintenance;
            this.declinedLoading = false;
          } else if (type === "closed") {
            this.closed = res.data.data.maintenanceRequests.sort(
              this.sortRequest
            );
            this.closedTotal = res.data.data.totalMaintenance;
            this.closedLoading = false;
          }
        })
        .catch(err => {
          this.pendingLoading = false;
          this.reviewLoading = false;
          this.toDeclineLoading = false;
          this.assessingLoading = false;
          this.followupLoading = false;
          this.completedLoading = false;
          this.reopenedLoading = false;
          this.escalatedLoading = false;
          this.declinedLoading = false;
          this.closedLoading = false;
        });
    },
    handlePagination(pageNumber, type) {
      const pageSizeKey = `${type.replace(/ /g, "")}PageSize`;
      const currentPageKey = `${type.replace(/ /g, "")}CurrentPage`;
      const loadingKey = `${type.replace(/ /g, "")}Loading`;
      const pagesKey = `${type.replace(/ /g, "")}Pages`;

      if (this[pageSizeKey] !== undefined) {
        this[currentPageKey] = pageNumber;
        this[pagesKey] = pageNumber; // Now using actual page numbers instead of offset
        this[loadingKey] = true;

        this.$router.replace({
          path: "/maintenance",
          query: {
            status: type,
            page: pageNumber,
            currentPage: pageNumber
          }
        });

        this.getRequest(pageNumber, this[pageSizeKey], type);
      }
    },
    lineStyle(status) {
      return [
        { all: status == "all" },
        { completed: status == "completed" },
        { pending: status == "pending" },
        { review: status == "in review" },
        { assessing: status == "assessing" },
        { follow: status == "follow up" },
        { declined: status == "declined" },
        { contested: status == "contested" },
        { closed: status == "closed" },
        { reopened: status == "reopened" },
        { escalated: status == "escalated" },
        { pendingDecline: status == "pending decline" }
      ];
    },
    statusStyle(status) {
      return [
        { all: status == "all" },
        { completed: status == "completed" },
        { pending: status == "pending" },
        { review: status == "in review" },
        { assessing: status == "assessing" },
        { follow: status == "follow up" },
        { declined: status == "declined" },
        { contested: status == "contested" },
        { closed: status == "closed" },
        { reopened: status == "reopened" },
        { escalated: status == "escalated" },
        { pendingDecline: status == "pending decline" }
      ];
    },
    toggleDataOptions() {
      this.showdataOptions = !this.showdataOptions;
    }
  },
  mounted() {
    const page = Number(this.$route.query.page);
    const currentPage = Number(this.$route.query.currentPage);
    const status = this.$route.query.status || "all";

    if (!page || page < 1 || !currentPage || currentPage < 1) {
      this.$router.replace({
        path: "/maintenance",
        query: {
          status,
          page: 1,
          currentPage: 1
        }
      });
    }
  },
  computed: {
    getPages() {
      return this.$route.query.page || 0;
    },
    curPage: {
      get() {
        return this.$route.query.currentPage || 1;
      },
      set(value) {
        this.currentPage = value;
      }
    },
    checkQuery() {
      if (this.$route.query) {
        return this.$route.query.status;
      }
      return "pending";
    },
    pageQuery() {
      if (this.$route.query) {
        return this.$route.query.page;
      } else return 1;
    },
    selectDragAttribute() {
      return {
        popover: {
          visibility: "hover",
          isInteractive: false // Defaults to true when using slot
        }
      };
    },
    ExportDataName() {
      if (this.dateRange) {
        return (
          this.formatExportDataName(this.dateRange.start) +
          "_" +
          this.formatExportDataName(this.dateRange.end)
        );
      } else {
        return "Last-30-days";
      }
    }
  }
};
</script>

<style scoped>
.maintenance__header {
  display: flex;
  width: 51%;
  justify-content: flex-start !important;
}

.maintenance__search {
  width: 250px;
  display: flex;
  gap: 12px;
}

.mtn__search_btn {
  width: 30% !important;
}

.disabled_csv {
  pointer-events: none;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/maintenance.vue